import React from "react";
import clsx from "clsx";
import { Dialog, DialogContent, Grid } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { ReadTextField } from "@icoach/components";

const getAddress = (receiverPostCode, receiverAddress) => {
	let address = "";
	if (receiverPostCode) address += receiverPostCode + " ";
	address += receiverAddress;
	return address;
};

const CyclePurchaseShippingDialog = ({ className, sourceData = {}, open, onClose }) => {
	const { receiverName, receiverMobile, receiverPostCode, receiverAddress, receiverNotes } = sourceData || {};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>收件人資訊</GradientColorHeader>
			<DialogContent>
				<Grid spacing={3} container>
					<Grid xs={12} item>
						<ReadTextField label={"收件人"}>{receiverName}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label={"收件人手機"}>{receiverMobile}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label={"收件地址"}>{getAddress(receiverPostCode, receiverAddress)}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label={"備註"}>{receiverNotes}</ReadTextField>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default CyclePurchaseShippingDialog;
